import SuspenseLoading from '@components/commons/SuspenseLoading';
import { AuthLayout, HomeLayout } from '@components/layouts';
import {
  MemberRegister,
  Dashboard,
  Login,
  Setting,
  MemberList,
  FaceIds,
  FaceIdDetail,
  FaceIdUpdate,
} from '@components/pages';
import { useAppSelector } from '@hooks';
import { Routes } from '@utils/constants';
import { FC, Suspense } from 'react';
import { Routes as BrowserRoutes, Navigate, Route } from 'react-router-dom';

const publicRoutes: IAppRoute[] = [
  {
    path: Routes.LOGIN,
    element: Login,
  },
  {
    path: Routes.SETTING,
    element: Setting,
  },
];

const privateRoutes: IAppRoute[] = [
  {
    path: Routes.DASHBOARD,
    element: Dashboard,
  },
  {
    path: Routes.MEMBER_LIST,
    element: MemberList,
  },
  {
    path: Routes.MEMBER_REGISTER,
    element: MemberRegister,
  },
  {
    path: Routes.MEMBER_UPDATE,
    element: MemberRegister,
  },
  {
    path: Routes.FACE_IDS,
    element: FaceIds,
  },
  {
    path: Routes.FACE_ID_DETAIL,
    element: FaceIdDetail,
  },
  {
    path: Routes.FACE_ID_EDIT,
    element: FaceIdUpdate,
  },
];

const AppRoutes: FC = () => {
  const { token } = useAppSelector((state) => state.auth);
  return (
    <BrowserRoutes>
      {!token ? (
        <Route element={<AuthLayout />}>
          {publicRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <Suspense fallback={<SuspenseLoading />}>
                  <route.element />
                </Suspense>
              }
            />
          ))}
          <Route
            path="*"
            element={<Navigate to={Routes.LOGIN} replace={true} />}
          />
        </Route>
      ) : (
        <Route element={<HomeLayout />}>
          {privateRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <Suspense fallback={<SuspenseLoading />}>
                  <route.element />
                </Suspense>
              }
            />
          ))}
          <Route
            path="*"
            element={<Navigate to={Routes.DASHBOARD} replace={true} />}
          />
        </Route>
      )}
    </BrowserRoutes>
  );
};

export default AppRoutes;
